import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useTheme } from '@mui/material/styles';
import { Order } from '../../../../app/services/api/orderManagementClient';

interface TopSellingProductsByValueProps {
  orders: Order[];
}

const TopSellingProductsByValue = ({ orders }: TopSellingProductsByValueProps) => {
  const theme = useTheme();

  // Aggregate sales by product (using orderType as a stand-in for product, replace with real product info if available)
  const productTotals: { [product: string]: number } = {};
  orders.forEach(order => {
    productTotals[order.orderType] = (productTotals[order.orderType] || 0) + (order.totalCost || 0);
  });
  const sorted = Object.entries(productTotals)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5);

  const data = sorted.map(([product, total]) => ({
    name: product,
    value: total / 1000, // Convert to thousands for display
  }));

  return (
    <ResponsiveContainer width="100%"
      height={200}>
      <BarChart data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3"
          stroke={theme.palette.divider} />
        <XAxis dataKey="name"
          stroke={theme.palette.text.primary}
          style={{ fontSize: theme.typography.textSM.fontSize }} />
        <YAxis stroke={theme.palette.text.primary}
          style={{ fontSize: theme.typography.textSM.fontSize }} />
        <Tooltip contentStyle={{ backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary, fontFamily: theme.typography.fontFamily, fontSize: theme.typography.textSM.fontSize }} />
        <Bar dataKey="value"
          fill={theme.palette.primary.main} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default TopSellingProductsByValue;